var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9182 6.62418C19.6702 6.82726 20.2612 7.41978 20.461 8.17087C20.8244 9.53397 20.8244 12.3798 20.8244 12.3798C20.8244 12.3798 20.8244 15.2256 20.461 16.5887C20.2584 17.3425 19.6674 17.9351 18.9182 18.1353C17.5586 18.4998 12.1034 18.4998 12.1034 18.4998C12.1034 18.4998 6.65109 18.4998 5.28869 18.1353C4.53674 17.9323 3.94572 17.3397 3.74594 16.5887C3.38245 15.2256 3.38245 12.3798 3.38245 12.3798C3.38245 12.3798 3.38245 9.53397 3.74594 8.17087C3.94849 7.417 4.53951 6.82447 5.28869 6.62418C6.65109 6.25977 12.1034 6.25977 12.1034 6.25977C12.1034 6.25977 17.5586 6.25977 18.9182 6.62418ZM14.8921 12.3798L10.3609 15.003V9.75651L14.8921 12.3798Z",
    fill: "#C5C5D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube24Px);
export default __webpack_public_path__ + "static/media/youtube-24px.1feebd3c8fc38e81eed60ffaa2e62d30.svg";
export { ForwardRef as ReactComponent };